export default "__VITE_ASSET__BefkAJMA__"